import { FormBaseTableComponent } from '../form-base-table/form-base-table.component';
import { Component } from '@angular/core';
import { TableComponent } from '../../../../../shared/components/kit/table/table.component';
import { PrimeTemplate } from '@openng/optimus-ui/api';
import { ButtonComponent } from '../../../../../../components/kit/button/button.component';

@Component({
    selector: 'app-form-opz-table',
    templateUrl: './form-opz-table.component.html',
    styleUrls: ['../form-base-table/form-base-table.scss'],
    imports: [
        TableComponent,
        PrimeTemplate,
        ButtonComponent,
    ],
})
export class FormOpzTableComponent extends FormBaseTableComponent {

    constructor() {
        super();
        this.generateColumns([]);
    }
}
